var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83179 41.7839C5.83179 34.1704 12.1925 27.9985 25.1904 27.9985C38.1884 27.9985 44.5491 34.1704 44.5491 41.7839C44.5491 42.9952 43.6654 43.9771 42.5753 43.9771H7.80561C6.7155 43.9771 5.83179 42.9952 5.83179 41.7839Z",
    stroke: "#4B4B4B",
    strokeWidth: 2.74248
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4499 12.5193C32.4499 16.5286 29.1997 19.7787 25.1904 19.7787C21.1811 19.7787 17.9309 16.5286 17.9309 12.5193C17.9309 8.50995 21.1811 5.25977 25.1904 5.25977C29.1997 5.25977 32.4499 8.50995 32.4499 12.5193Z",
    stroke: "#4B4B4B",
    strokeWidth: 2.74248
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.dfdcf736bd864f1169080f258e28b9d4.svg";
export { ForwardRef as ReactComponent };